import React from "react";
import styles from "./FilterHeadToHeadWarning.module.scss";
import FilterHeaderWarning from "../FilterHeaderWarning";

const FilterHeadToHeadWarning = () => {
  return (
    <FilterHeaderWarning styleClass={styles.h2hWarning}>
      <p>No stats available for Head to Head</p>
    </FilterHeaderWarning>
  );
};

export default FilterHeadToHeadWarning;
